import { Icon } from '@iconify/react';
import driverFilled from '@iconify/icons-fa-solid/user-tie';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.error.darker,
  backgroundColor: theme.palette.error.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.error.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.error.dark, 0)} 0%, ${alpha(
    theme.palette.error.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const TOTAL = 234;

export default function AppEvent(props) {
  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={driverFilled} width={25} height={25} />
      </IconWrapperStyle>
      <Typography variant="h3">
        {props.TOTAL}
        {props.unit}
      </Typography>
      <Typography variant="h4" sx={{ opacity: 0.72 }}>
        {props.title}
      </Typography>
    </RootStyle>
  );
}
